import {
  JoinPaymentMethodRadioListProps,
  JoinSelectPaymentMethodContentsProps,
} from '../../Join/Components/JoinSelectPaymentMethodContents'
import {
  ContractMethod,
  getContractMethodsByTerm,
  MyCreditCardInfo,
  PaymentInputDetail,
} from '../../../../Props/ContractInputInfo'
import {SelectCreditCardRadioListForProps} from '../../../Components/PaymentsRelations/InputContentBlocks/SelectCreditCardRadioList'
import React from 'react'
import {PIMCard} from '../../../Atoms/Cards/PIMCard'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {
  MBContentBodyItemWarningMessageTypography,
  MBContentNoteWithMarkTypography,
} from '../../../Atoms/Typographies'
import {MBMemberError} from '../../../../Common/MBMemberError'
import {EditDisplayPaymentMethodsRadioList} from './EditDisplayPaymentMethodsRadioList'
import {Nullable} from '../../../../../Common/TypeHelper'
import {ContractInfo, NextContractInfo} from '../../../../DTO/MemberContractInfoDTO'

type ChangeNextPaymentMethodContentProps = JoinSelectPaymentMethodContentsProps & {
  displayMyCreditCardExcludeCurrentCard: boolean
  isChangeContractTerm: boolean
  isDisableContractMethodRadioButton: boolean
  creditCardInfoForNextContract: Nullable<MyCreditCardInfo>
  nextContractInfoBeforeChange: Pick<NextContractInfo, 'contractMethod'>
  nowContractInfo: Pick<ContractInfo, 'term' | 'endDate'>
} & Required<Pick<SelectCreditCardRadioListForProps, 'nextContractStartDate_YYYYMMDD'>>

export const ChangeNextPaymentMethodContent: React.VFC<ChangeNextPaymentMethodContentProps> = (
  {
    paymentMethodList,
    myCreditCardInfoList,
    contractInputInfoState,
    onChangeSelectedMethod,
    onChangeInputDetailInfo,
    errorMessages,
    onDeleteCardButtonClick,
    displayMyCreditCardExcludeCurrentCard,
    isChangeContractTerm,
    isDisableContractMethodRadioButton,
    creditCardInfoForNextContract,
    nextContractStartDate_YYYYMMDD,
    nextContractInfoBeforeChange,
    nowContractInfo,
  },
) => {
  const contractMethods = getContractMethodsByTerm(paymentMethodList, contractInputInfoState.term)

  return (
    <PIMCard
      headerProps={{title: '次回契約のお支払い方法の変更', require: true}}
      testId={'block-input-next-payment-method'}
    >
      <PIMStack spacing={'18px'}>
        <PIMStack spacing={'6px'}>
          <MBContentNoteWithMarkTypography
            note={'次回契約のお支払い時に利用可能なクレジットカード情報のみ選択可能となっております。'}
          />
          {errorMessages.paymentInputMethodErrors.map((error, idx) => (
            <MBContentBodyItemWarningMessageTypography key={idx}>
              {error}
            </MBContentBodyItemWarningMessageTypography>
          ))}
        </PIMStack>

        <EditPaymentMethodRadioList
          contractMethods={contractMethods}
          myCreditCardInfoList={myCreditCardInfoList}
          contractInputInfo={contractInputInfoState}
          errorMessages={errorMessages}
          onChangeSelectedMethod={(changeSelectedMethod: ContractMethod): void => {
            onChangeSelectedMethod(changeSelectedMethod)
          }}
          onChangeInputDetailInfo={(changeInputDetailInfo: PaymentInputDetail): void => {
            onChangeInputDetailInfo(changeInputDetailInfo)
          }}
          onDeleteCardButtonClick={onDeleteCardButtonClick}
          displayMyCreditCardExcludeCurrentCard={displayMyCreditCardExcludeCurrentCard}
          isChangeContractTerm={isChangeContractTerm}
          isDisableContractMethodRadioButton={isDisableContractMethodRadioButton}
          creditCardInfoForNextContract={creditCardInfoForNextContract}
          nextContractStartDate_YYYYMMDD={nextContractStartDate_YYYYMMDD}
          nextContractInfoBeforeChange={nextContractInfoBeforeChange}
          nowContractInfo={nowContractInfo}
        />
      </PIMStack>
    </PIMCard>
  )
}
type EditPaymentMethodRadioListProps = JoinPaymentMethodRadioListProps & {
  displayMyCreditCardExcludeCurrentCard: boolean
  isChangeContractTerm: boolean
  isDisableContractMethodRadioButton: boolean
  creditCardInfoForNextContract: Nullable<MyCreditCardInfo>
  nextContractInfoBeforeChange: Pick<NextContractInfo, 'contractMethod'>
  nowContractInfo: Pick<ContractInfo, 'term' | 'endDate'>
} & Required<Pick<SelectCreditCardRadioListForProps, 'nextContractStartDate_YYYYMMDD'>>

const EditPaymentMethodRadioList: React.VFC<EditPaymentMethodRadioListProps> = (
  {
    contractMethods,
    myCreditCardInfoList,
    contractInputInfo,
    errorMessages,
    onChangeSelectedMethod,
    onChangeInputDetailInfo,
    onDeleteCardButtonClick,
    displayMyCreditCardExcludeCurrentCard,
    isChangeContractTerm,
    isDisableContractMethodRadioButton,
    creditCardInfoForNextContract,
    nextContractStartDate_YYYYMMDD,
    nextContractInfoBeforeChange,
    nowContractInfo,
  },
) => {
  if (Object.keys(contractMethods).length === 0) {
    throw new MBMemberError('SystemError')
  }

  const disabled = (contractInputInfo.term === '' && isDisableContractMethodRadioButton)

  return <EditDisplayPaymentMethodsRadioList
    paymentMethodList={contractMethods}
    myCreditCardInfoList={myCreditCardInfoList}
    paymentInputDetailWithMethod={contractInputInfo}
    disabled={disabled}
    errorMessages={errorMessages}
    onChangeSelectedMethod={(value: ContractMethod): void => onChangeSelectedMethod(value)}
    onChangeInputDetailInfo={(value: PaymentInputDetail): void => onChangeInputDetailInfo(value)}
    onDeleteCardButtonClick={onDeleteCardButtonClick}
    displayMyCreditCardExcludeCurrentCard={displayMyCreditCardExcludeCurrentCard}
    isChangeContractTerm={isChangeContractTerm}
    creditCardInfoForNextContract={creditCardInfoForNextContract}
    nextContractStartDate_YYYYMMDD={nextContractStartDate_YYYYMMDD}
    nextContractInfoBeforeChange={nextContractInfoBeforeChange}
    nowContractInfo={nowContractInfo}
  />
}
